import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import {
  LOAD_USER_PROFILE,
} from '../constants';

export const initialState = fromJS({
  isAuthorized: false,
  loginRequestError: false,
  profile: {},
});

function loadUserProfileHandler(state, action) {
  return state
    .set('profile', fromJS(action.payload.body));
}

export default handleActions({
  [LOAD_USER_PROFILE]: loadUserProfileHandler,
}, initialState);



// WEBPACK FOOTER //
// ./redux/user/reducer.js